import React from 'react';

const SuccessNotification = ({ message, onClose }) => (
  <div style={{
    position: 'fixed',
    top: 20,
    right: 20,
    background: '#22c55e',
    color: 'white',
    padding: '16px 24px',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    zIndex: 1000,
    minWidth: 200,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: 12
  }}>
    <span>{message}</span>
    <button onClick={onClose} style={{
      background: 'transparent',
      border: 'none',
      color: 'white',
      fontWeight: 'bold',
      fontSize: 18,
      marginLeft: 12,
      cursor: 'pointer',
      lineHeight: 1
    }}>&times;</button>
  </div>
);

export default SuccessNotification;
